export default class EditWorkDayController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    moment,
    EmployeeService,
    UtilService,
    workDay
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.EmployeeService = EmployeeService;
    this.UtilService = UtilService;
    this.workDay = workDay;

    this.date = this.moment(this.workDay.date).toDate();
    if (this.workDay.startTime) {
      this.startTime = this.moment(this.UtilService.parseTime(this.workDay.startTime)).format('HH:mm');
    }

    if (this.workDay.endTime) {
      this.endTime = this.moment(this.UtilService.parseTime(this.workDay.endTime)).format('HH:mm');
    }
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  delete() {
    this.EmployeeService.deleteWorkDay(this.workDay.employeeId, this.workDay.id)
      .then(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Usunięto wpis.')
            .position('bottom right')
            .hideDelay(3000)
        );
        this.$mdDialog.hide();
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  update(form) {
    if (form.$invalid) {
      return false;
    }

    this.workDay.date = this.moment(this.date).format('YYYY-MM-DD');
    this.workDay.startTime = this.startTime;
    this.workDay.endTime = this.endTime;
    this.EmployeeService.editWorkDay(this.workDay.employeeId, this.workDay)
      .then(() => {
        this.$mdDialog.hide();
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Edytwano wpis.')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}
